export default "__VITE_ASSET__CiZaze91__"